<script setup lang="ts">
import { darkModeIconMap } from '~/models/elementsUi'
import type { DarkModeType } from '~/types/elementsUi'

const localeStore = useLocaleStore()

const { locale, setLocale } = useI18n()
const darkMode = useColorMode()

const changeLocale = () => {
  const newLocale = locale.value === 'nl' ? 'en' : 'nl'

  setLocale(newLocale)
  localeStore.locale = newLocale
}

const darkModeIcon = computed(() => darkModeIconMap[darkMode.preference as DarkModeType])
const toggleDarkMode = () => {
  darkMode.preference = darkMode.preference === 'light' ? 'dark' : 'light'
}

const route = useRoute()
const baseUrl = computed(() => window.location.origin + route.path)
</script>

<template>
  <div
    class="fixed right-0 bottom-0 left-0 z-1000 mx-auto h-14 w-fit max-w-48 rounded-t-xl border border-b-0 border-accented bg-default p-4"
  >
    <div class="flex w-full items-center justify-center gap-2">
      <VIcon :icon="darkModeIcon" @click="toggleDarkMode" />
      <VIcon
        :icon="`fi-${locale === 'en' ? 'gb' : 'nl'}`"
        icon-pack="fi"
        @click="changeLocale"
      />
      <span class="font-semibold">Preview</span>
      <VLink :href="baseUrl" target="_blank">
        <VIcon icon="fa-arrow-up-right-from-square" class="text-default!" />
      </VLink>
    </div>
  </div>
</template>

<style scoped></style>
